import Inputmask from 'inputmask';

window.Inputmask = Inputmask
